import api from "../api";

export const getHubspotToken = async (firstName, lastName, email) => {
  try {
    const response = await api.post(
      "/hubspot-token",
      {
        firstName,
        lastName,
        email,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data.token;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error(
      error.message || "Something went wrong while fetching HubSpot token."
    );
  }
};
